export enum ResourceType {
  BusinessTypes = 'business-types',
  Departments = 'departments',
  Timezones = 'timezones',
  Currency = 'currency',
}
